// extracted by mini-css-extract-plugin
export default {"container":"GridMessage_container__Mq1aI"};